export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            关于吃瓜黑料爆料
          </h2>
          <p className="text-foreground-500 text-sm">了解你身边的八卦资讯平台</p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-xl p-8 md:p-10">
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
            <strong className="text-foreground-950">吃瓜黑料爆料网</strong>是国内领先的娱乐八卦聚合平台，专注于收集、整理和发布娱乐圈最新黑料与明星八卦爆料。
          </p>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
            我们以<strong className="text-foreground-950">"让每一条瓜料都有据可查"</strong>为宗旨，为广大瓜友提供最新、最全、最热的吃瓜体验。平台内容涵盖<strong className="text-primary-600">出轨内幕、丑闻细节、合约纠纷、私生活揭秘</strong>等多个维度，每日持续更新，确保您不错过任何一条重磅瓜料。
          </p>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            无论是近期吃瓜事件盘点，还是经典黑料整理回顾，吃瓜黑料爆料网始终致力于成为您浏览娱乐八卦的第一站。我们坚持内容真实、来源可溯的原则，在娱乐资讯的快节奏中，为您提供有深度、有态度的八卦内容。
          </p>
        </div>
      </div>
    </section>
  );
}